import { render } from "./InterestSetModal.vue?vue&type=template&id=20268eb2&scoped=true"
import script from "./InterestSetModal.vue?vue&type=script&lang=js"
export * from "./InterestSetModal.vue?vue&type=script&lang=js"

import "./InterestSetModal.vue?vue&type=style&index=0&id=20268eb2&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20268eb2"]])

export default __exports__